import { onMounted, onBeforeUnmount } from 'vue';
import { disableBodyScroll, enableBodyScroll } from '@component_path/lib/body-scroll-lock';

export const setupModal = (selectors) => {
  onMounted(() => {
    const modal = document.querySelector(selectors)
    disableBodyScroll(modal)
  })

  onBeforeUnmount(() => enableBodyScroll())
}
